import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import _ from "lodash";
import TitleBar from "../_common/TitleBar";
import { notifLayouts } from "./notifLayoutHelper";
import "./styles/notif.css";

class NotifCenter extends Component {
  state = {
    sortColumn: { path: "raisedOn", order: "desc" }
  };

  columns = [
    { path: "senderFullName", label: "Notification From" },
    {
      path: "raisedOn",
      label: "On",
      content: notif => moment(notif.raisedOn).format("MM/DD/YYYY HH:MM")
    },
    { path: "notificationType", label: "Notification For" },
    {
      path: "isDismissed",
      label: "Status",
      content: notif => this.renderStatus(notif.isDismissed)
    },
    {
      path: "notificationId",
      label: "Actions",
      content: notif => this.renderAction(notif)
    }
  ];

  handleSort = sortColumn => this.setState({ sortColumn });

  getData = () => {
    const { notifications } = this.props.authentication.user;

    // Check for undefined condition
    if (notifications) {
      const { sortColumn } = this.state;
      return _.orderBy(notifications, [sortColumn.path], [sortColumn.order]);
    } else return [];
  };

  renderStatus = isDismissed => {
    let badgeColor = isDismissed ? "secondary" : "danger";
    return (
      <span className={`span-bubble p-1 bg-${badgeColor}`}>
        {isDismissed ? "Dismissed" : "New"}
      </span>
    );
  };

  renderAction = notif => {
    let actionLabel = "";
    switch (notif.notificationType) {
      case "ADR_SUBMITTED":
        actionLabel = "Review";
        break;
      default:
        break;
    }
    return (
      <button
        type="button"
        className="btn btn-sm btn-outline-secondary"
        onClick={() => alert(notif.raisedOn)}
      >
        {actionLabel}
      </button>
    );
  };

  render() {
    // const { sortColumn } = this.state;
    const data = this.getData();
    return (
      <React.Fragment>
        <TitleBar titleText={"Notification Center"} />
        <div className="card m-2">
          <div className="card-body p-2">
            <div className="list-group w-50 m-2">
              {data.length > 0 &&
                data.map((n, index) => (
                  <div
                    className={
                      "list-group-item list-group-item-" +
                      notifLayouts[n.notificationType].color +
                      " border-" +
                      notifLayouts[n.notificationType].color
                    }
                    key={`notifKey_${index}`}
                  >
                    <div className="d-flex w-100 justify-content-between">
                      <span className="badge badge-danger pb-1 mb-1">
                        {notifLayouts[n.notificationType].badgeText}
                      </span>
                      <small>
                        {notifLayouts[n.notificationType].notifSince(n)}
                      </small>
                    </div>
                    <div className="d-flex w-100 justify-content-between align-items-center">
                      <span className="h5 mb-1">{n.title}</span>
                      {notifLayouts[n.notificationType].actionButtons.length >
                        0 &&
                        notifLayouts[n.notificationType].actionButtons.map(
                          (btn, abIndex) => (
                            <button
                              key={`notifActionButtonIndex_${index}_${abIndex}`}
                              type="button"
                              className={
                                "btn btn-sm btn-" +
                                notifLayouts[n.notificationType].color
                              }
                            >
                              {btn}
                            </button>
                          )
                        )}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  notifications: state.authentication.user.notifications,
  authentication: state.authentication
});

export default connect(mapStateToProps)(NotifCenter);
